module.exports = __webpack_public_path__ + "static/media/img-splash.9caf1da7.png";